import { Link } from 'react-router-dom';
import Reveal from './Reveal';

interface CTASectionProps {
  title?: string;
  description?: string;
  buttonText?: string;
  closing?: string;
  compact?: boolean;
  to?: string;
}

export default function CTASection({
  title = '成長を止めている課題を相談しませんか？',
  description = '会社の成長を妨げている業務・情報・判断の滞りを、AIの活用で改善します。まずは無料相談で、御社の課題をお聞かせください。',
  buttonText = '成長を止めている課題を相談する',
  closing,
  compact = false,
  to = '/contact/',
}: CTASectionProps) {
  return (
    <section
      className={`relative overflow-hidden px-4 md:px-6 bg-[#12121f] ${compact ? 'py-16 md:py-24' : 'py-24 md:py-32'}`}
    >
      <div
        className="blob w-[500px] h-[500px] -top-40 -left-40"
        style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)' }}
      ></div>
      <div
        className="blob w-[400px] h-[400px] -bottom-40 -right-40"
        style={{ background: 'linear-gradient(135deg, #a855f7, #7c3aed)', animationDelay: '-10s' }}
      ></div>

      <Reveal
        className={`relative mx-auto bg-[#1a1a2e] border border-[#2a2a3e] rounded-3xl ${
          compact ? 'max-w-3xl p-8 md:p-12' : 'max-w-3xl p-10 md:p-16'
        }`}
      >
        <h2 className="text-2xl md:text-4xl font-extrabold text-white">{title}</h2>
        <p className="mt-5 text-[#a0a0b0] text-base md:text-lg leading-relaxed">{description}</p>
        <div className="mt-8 flex justify-center">
          <Link
            to={to}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl h-12 px-8 text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#a855f7] text-white transition-all duration-300 hover:brightness-110 hover:scale-[1.02] hover:shadow-[0_14px_30px_rgba(124,58,237,0.4)]"
          >
            {buttonText}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        {closing && (
          <div className="mt-10 pt-8 border-t border-[#2a2a3e] max-w-2xl mx-auto">
            <p className="text-base md:text-lg text-[#e8e8f0] leading-loose">{closing}</p>
          </div>
        )}
      </Reveal>
    </section>
  );
}